import type { EntityAdapter } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type {
  CompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import type { PoolOutput } from 'core/http/project';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  initialCompletedEntityState,
} from 'app/store/completed-entity-state/completed-entity-state';
import * as PoolsActions from './pools.actions';

export interface PoolsState extends CompletedEntityState<PoolOutput> {}

const adapter: EntityAdapter<PoolOutput> = createEntityAdapter<PoolOutput>();

export const initialPoolsState = adapter.getInitialState<PoolsState>(initialCompletedEntityState);

const reducer = createReducer(
  initialPoolsState,
  on(PoolsActions.savePools, (state, { pools }) => adapter.setAll(pools, state)),
  on(PoolsActions.addPoolInStore, (state, pool) => adapter.addOne(pool, state)),
  on(PoolsActions.markPoolsLoaded, state => ({ ...state, loaded: true })),
  on(PoolsActions.updatePoolInStore, (state, { update }) => adapter.updateOne(update, state)),
  on(PoolsActions.removePoolFromStore, (state, { id }) => adapter.removeOne(id, state)),
  on(PoolsActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(PoolsActions.setError, (state, { value }) => ({ ...state, error: value })),
);

export function poolsReducer(state: PoolsState | undefined, action: Action): PoolsState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();
